module.exports = __webpack_public_path__ + "static/media/triporg--logo.7ec5c6ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/triporg/triporg--logo.png
// module id = 167
// module chunks = 0